// Styled components for Sensor Debug Tool

import styled from 'styled-components';

export const Content = styled.div`
  padding: 1.5rem;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
`;

export const Header = styled.div`
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
`;

export const Title = styled.h2`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Panel = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 1rem;
`;

export const PanelTitle = styled.h3`
  margin: 0 0 1rem 0;
  display: flex;
  align-items: center;
`;

interface ButtonProps {
  primary?: boolean;
  danger?: boolean;
}

export const Button = styled.button<ButtonProps>`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  background: ${props => (props.primary ? '#2196F3' : props.danger ? '#f44336' : 'rgba(255, 255, 255, 0.1)')};
  color: white;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  padding: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.05);
  color: white;
  font-family: monospace;

  &:focus {
    outline: none;
    border-color: #2196f3;
  }

  &::placeholder {
    opacity: 0.5;
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
`;

interface InfoBoxContainerProps {
  variant?: 'info' | 'success' | 'error';
}

export const InfoBoxContainer = styled.div<InfoBoxContainerProps>`
  padding: 1rem;
  background: ${props => {
    switch (props.variant) {
      case 'success':
        return 'rgba(76, 175, 80, 0.1)';
      case 'error':
        return 'rgba(244, 67, 54, 0.1)';
      default:
        return 'rgba(33, 150, 243, 0.1)';
    }
  }};
  border: 1px solid
    ${props => {
      switch (props.variant) {
        case 'success':
          return 'rgba(76, 175, 80, 0.3)';
        case 'error':
          return 'rgba(244, 67, 54, 0.3)';
        default:
          return 'rgba(33, 150, 243, 0.3)';
      }
    }};
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const WarningBoxContainer = styled.div`
  padding: 0.75rem;
  background: rgba(255, 152, 0, 0.1);
  border: 1px solid rgba(255, 152, 0, 0.3);
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
